var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16PxAntenna(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    width: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "antenna") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 5.5,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 15.5,
    x2: 7.5,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 15.5,
    x2: 10.5,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.328,8.328a4,4,0,0,0,0-5.656",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.45,10.45a7,7,0,0,0,0-9.9",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.672,8.328a4,4,0,0,1,0-5.656",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55,10.45a7,7,0,0,1,0-9.9",
    stroke: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16PxAntenna);
export default __webpack_public_path__ + "static/media/16px_antenna.571836d1ede7db060e4faccc96d464a6.svg";
export { ForwardRef as ReactComponent };